module.exports = __webpack_public_path__ + "static/badge-image-829901eac67651405d8b8fbfa771a1e8.png";